<template>
<div class='upload-view'>
  <div class='upload-wrapper'>
    <div class='before-upload' v-show='!onUploading'>
      <div class='upload-image img'></div>
      <p class='hint'>{{$t('supportFormat')}}</p>
      <div class='uploader-btn'>
        <qiniuuploader btnType="primary" :btnPlain="false" :label="$t('chooseSubmit')" :url="targetUrl" :accept="accept" :extensions="allowedExtensions" :filename.sync="filename" :filesize.sync="filesize" :progress.sync="progress" :uploading.sync="onUploading"
          @complete="uploadDone" @error="uploadFail" v-if="uploader === 'qiniu'" />
        <nginxuploader :label="$t('chooseSubmit')" :url="targetUrl" :accept="accept" :extensions="allowedExtensions" :filename.sync="filename" :filesize.sync="filesize" :progress.sync="progress" :uploading.sync="onUploading" @complete="uploadDone" @error="uploadFail"
          v-else-if="uploader === 'nginx'" />
        <ssuploader btnType="primary" :btnPlain="false" :label="$t('chooseSubmit')" :url="targetUrl" :accept="accept" :extensions="allowedExtensions" :filename.sync="filename" :filesize.sync="filesize" :progress.sync="progress" :uploading.sync="onUploading" @complete="uploadDone"
          @error="uploadFail" v-else-if="uploader === 'ss'" />
      </div>
    </div>
    <div class='uploading' v-show='onUploading'>
      <div class='upload-image img'></div>
      <div class='progress-area'>
        <div class='left'>
          <p>{{filename}}</p>
        </div>
        <div class='right'>
          <p>{{sizeReadable(filesize)}}</p>
        </div>
        <el-progress :text-inside="true" :stroke-width="18" :percentage="progress">
        </el-progress>
      </div>
      <div class='uploading-hint' v-if="!tbcMode">
        <p class='hint'>上传遇到问题？请更换
          <a class='link' href="http://ppj.io/docs/#/browsers" target="_blank">
              其他浏览器</a> 重试，或
          <a class='link' href="http://ppj.io/docs/#/feedback" target="_blank">联系我们</a>
        </p>
      </div>
    </div>
  </div>

  <div class='tempaltes-frame' v-if="!tbcMode">
    <div class='qrcode'>
      <div class='img' :style="{backgroundImage: 'url('+'//qrcode.ppj.io/http://h5.ppj.io/yhiCzynw/index.html?v=10)'}"></div>
      <p class='hint'>PPT也能做竖版？<br />1分钟成为H5达人！</p>
    </div>

    <div class='links'>
      <a class='text-btn template' href='https://pan.baidu.com/s/1gfN4jJl' target="_blank"><i class='ppj-icon-gift'></i>福利！海量H5模板下载</a>
    </div>
  </div>
</div>
</template>

<i18n>
{
  "zh-cn": {
    "supportFormat": "支持格式：pptx ppt dps pdf",
    "chooseSubmit": "选择上传"
  }
}
</i18n>

<script>
import logger from '@/assets/scripts/logger'
import SSUploader from '@/components/widgets/ss_uploader.input'
import NginxUploader from '@/components/widgets/nginx_uploader.input'
import QiniuUploader from '@/components/widgets/qiniu_uploader.input'

const supportXHRUpload = !!(window.ProgressEvent && window.FileReader) || !!window.FormData

let checkTimer = null
let interval = 0

let check = (create = false) => {
  let vm = this
  interval += 1
  logger.info(`interval: ${interval} * 5 seconds`)

  if (interval % 60 === 0) {
    logger.error(`当前上传时间已经为 ${interval} * 5 seconds, 进度为 ${vm.progress}, 大小为 ${vm.sizeReadable(vm.filesize)}`)
  }

  if (create || checkTimer) {
    checkTimer = setTimeout(check, 5000)
  }
}

let clearCheck = () => {
  if (checkTimer) {
    clearTimeout(checkTimer)
    checkTimer = null
    interval = 0
  }
}

export default {
  data() {
    return {
      uploader: supportXHRUpload ? 'qiniu' : 'ss', // 'qiniu', 'nginx', 'ss'
      project_id: null,
      onUploading: false,
      filename: null,
      filesize: null,
      progress: 0,
      accept: '.pptx, .ppt, .dps, .pdf, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.ms-powerpoint, application/pdf, application/dps',
      allowedExtensions: ['ppt', 'pptx', 'dps', 'pdf']
    }
  },
  components: {
    'ssuploader': SSUploader,
    'nginxuploader': NginxUploader,
    'qiniuuploader': QiniuUploader
  },
  watch: {
    onUploading: function(newValue) {
      newValue ? check.call(this, true) : clearCheck()
    }
  },
  computed: {
    targetUrl() {
      return this.supportXHRUpload ? `${process.env.API_ROOT}uploads` : `${process.env.API_ROOT}misc/fast_upload`
    },
    tbcMode() {
      return this.$store.state.tbcMode
    }
  },
  methods: {
    uploadDone(params) {
      let vm = this
      let success = function(res) {
        clearCheck()
        // 导航到 project 查看页面
        vm.$router.push(`/projects/${res.data.id}`)
        // update this view's ui
        vm.onUploading = false
      }

      let failure = function(err) {
        let data = err.response.data
        logger.error(`upload success, fail on create project: ${JSON.stringify(data)}`)
        // possible error:
        if (data.type === 'UploadedFileNotExistsError') {
          vm.$message({
            message: err.response.data.message,
            type: 'error',
            showClose: true,
            duration: 0
          })
        }

        // update this view's ui
        vm.onUploading = false
      }

      if (!params || !(params.session_id || params.qn_file_id)) {
        logger.error('file_id is not appropriately get.')
        vm.$message({ message: '未知错误，请重新上传', type: 'error' })
        return
      }
      let fileId = params.session_id
      let qnFileId = params.qn_file_id
      if (!vm.$route.params.id) {
        // new project need to create
        vm.$store.dispatch('project/create', {
          source_filename: vm.filename,
          category_id: vm.$route.query.catId,
          file_id: fileId,
          qn_file_id: qnFileId
        }).then(success).catch(failure)
      } else {
        vm.$store.dispatch('project/update', {
          id: vm.$route.params.id,
          source_filename: vm.filename,
          file_id: fileId,
          qn_file_id: qnFileId
        }).then(success).catch(failure)
      }
    },
    uploadFail(params) {
      // do not send $message here
      clearCheck()
      logger.error(`upload failure, fallback from ${params} to ss`)
      if (params !== 'ss') {
        this.uploader = 'ss'
      }
      this.onUploading = false
    }
  },
  beforeRouteLeave(to, from, next) {
    clearCheck()
    next()
  }
}
</script>

<style lang='scss' scoped>
.upload-view {
    padding-top: 0;
    position: relative;
    .upload-wrapper {
        // upload image
        text-align: center;
        min-height: 480px;
        background-color: $color-white-base;
        $upload-image-width: 200px;
        .upload-image {
            margin: $margin-base auto;
            width: $upload-image-width;
            height: $upload-image-width;
            background-image: url("~@/assets/images/project-upload.png");
        }

        .before-upload {
            padding-top: 60px;
            .hint {
                margin: 50px 0 20px;
            }
        }

        .uploading {
            padding-top: 1px;
            .upload-image {
                width: 90px;
                height: 90px;
                margin: 60px auto;
            }

            .progress-area {
                width: 600px;
                margin: 0 auto;
                overflow: hidden;

                .el-progress {
                    float: left;
                    width: 100%;
                }
            }

            .uploading-hint {
                width: 600px;
                margin: 0 auto;
                overflow: hidden;
                margin-top: $margin-base;
            }
        }
    }

    .tempaltes-frame {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 160px;
        text-align: center;

        .qrcode {
            margin-left: 20px;
            background-color: $color-gray-extreme-light;
            width: 140px;
            padding-top: 15px;
            padding-bottom: 10px;

            .img {
                position: relative;
                width: 110px;
                height: 110px;
                margin-bottom: 5px;
            }

            .hint {
                line-height: 1.5;
                margin-top: 10px;
                margin-bottom: 0;
            }
        }

        .links {
            text-align: right;
            margin-top: 20px;
            font-size: $font-size-small;
            white-space: nowrap;

            .template {
                .ppj-icon-gift {
                    margin-right: 0.4em;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?e3e3c5c2